import React from "react";
import Layout from "../components/Layout";
import SEOHead from "../components/SEOHead";
import PageHeader from "../components/PageHeader";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { IconBudget, IconCyber, IconInfrastructure, IconAI, IconWater, IconDataMonitor } from "../brand/icons";

const rows = [
  { I: IconBudget, t: "Budget Risk Engine", d: "Scores department growth, project escalation, vendor concentration, transparency." },
  { I: IconInfrastructure, t: "Infrastructure Risk", d: "Roads, drainage, water, parks, resilience, and deferred maintenance." },
  { I: IconCyber, t: "Cybersecurity Layer", d: "24/7 AI monitor, device trust, API security, incident queue." },
  { I: IconWater, t: "CyberWater Security", d: "PLC, pump, valve, AWG protection with multi-party control." },
  { I: IconAI, t: "AI Recommendations", d: "Reallocation options framed as decision-support, not accusation." },
  { I: IconDataMonitor, t: "Dashboards & Reports", d: "Executive-grade navy + gold panels, investor-ready visuals." },
];

const Platform = () => (
  <Layout>
    <SEOHead title="Platform Overview | AuditIQ" path="/platform"
      description="AuditIQ platform overview: budget scanner, infrastructure risk, cybersecurity layer, CyberWater, AI recommendations, and executive dashboards." />
    <PageHeader eyebrow="Platform" title="Every accountability layer, one system."
      subtitle="AuditIQ is built in modules — each can run alone, all share the same data fabric, transparency scoring, and brand-consistent dashboards." />
    <section className="max-w-[1400px] mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
      {rows.map(({ I, t, d }) => (
        <div key={t} className="panel-elev p-7">
          <I size={28} />
          <div className="font-display text-xl mt-4">{t}</div>
          <div className="text-sm text-cream-dim mt-2 leading-relaxed">{d}</div>
        </div>
      ))}
    </section>
    <section className="max-w-[1400px] mx-auto px-6 pb-20">
      <div className="gold-rule my-10" />
      <div className="flex items-center justify-between flex-wrap gap-4">
        <h3 className="font-display text-3xl">Ready to walk through a live scenario?</h3>
        <div className="flex gap-3">
          <Link to="/demo"><Button className="btn-gold h-11 px-5" data-testid="platform-to-demo">Launch Demo</Button></Link>
          <Link to="/brand"><Button className="btn-ghost-gold h-11 px-5" data-testid="platform-to-brand">View Brand System</Button></Link>
        </div>
      </div>
    </section>
  </Layout>
);

export default Platform;
